module.exports = __webpack_public_path__ + "img/PL08111.57c067f4.png";